import { HTTP } from './http-common'
import * as _ from 'lodash'

export default {
  endpoint: '/user',

  list (params) {
    let url = this.endpoint + '?'
    if (params) {
      for (let key in params) {
        url += key + '=' + params[key] + '&'
      }
    }
    return HTTP.get(url)
  },

  get (userId, params) {
    let url = this.endpoint + '/' + userId + '?'
    if (params) {
      for (let key in params) {
        url += key + '=' + params[key] + '&'
      }
    }
    return HTTP.get(url)
  },

  save (user) {
    return HTTP.post(this.endpoint, user)
  },

  update (user) {
    let url = this.endpoint + '/' + user.id
    let registro = _.omit(user, ['usuarioCreacion', 'propietario']);
    return HTTP.patch(url, registro)
  },

  delete (userId) {
    let url = this.endpoint + '/' + userId
    return HTTP.delete(url)
  },

  count() {
    let url = '/total' + this.endpoint
    return HTTP.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/services/usuarios.js